import { render, staticRenderFns } from "./VerticalNavMenuSchoolSwitcher.vue?vue&type=template&id=0eb41114&"
import script from "./VerticalNavMenuSchoolSwitcher.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuSchoolSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports